import getMuiTheme from 'material-ui/styles/getMuiTheme';

import uiColors from 'static/three-oh/src/components/Colors/colors';

// To see what are the values you can override, view:
// https://github.com/mui-org/material-ui/blob/master/src/styles/getMuiTheme.js
const newselaMuiTheme = getMuiTheme({
  menuItem: {
    hoverColor: uiColors.light_blue[1]
  },
  ripple: {
    color: 'transparent'
  }
});

export default newselaMuiTheme;
